// extracted by mini-css-extract-plugin
module.exports = {"arrow":"view-all-reviews_arrow__9QDdt","arrowNudge":"view-all-reviews_arrowNudge__yfpUH"};